var _defs, _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSteeringrRearAxle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 800 800",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        fill: #3b66b0;\r\n        stroke-width: 0px;\r\n      }\r\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M548.3,417.3c-3.6-2.4-6-4.2-10.2-4.2h-119.4c-4.8,0-6-8.4-6,6s1.2,29.9,0,44.3c-1.2,16.2,3,27.5,15.6,37.1,4.2,3.6,7.8,6,13.8,6h86.7v.6s29.1,0,29.1,0c6,0,7.8,5.4,7.8-7.8s-1.2-28.1,0-41.3c1.8-17.9-4.2-30.5-17.3-40.7ZM532.8,479.5h-11.2v-.6s-70.6,0-70.6,0c-7.8,0-11.4-3.6-11.4-11.4v-23.3c0-4.2,1.2-5.4,5.4-5.4h84.2c6.6,0,10.2,3.6,10.2,10.2v23.3c.6,5.4-.6,7.2-6.6,7.2Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M187.8,399.9c-36.5.6-66.4,29.9-66.4,66.4s29.9,66.4,66.4,66.4,66.4-29.9,66.4-66.4c.6-36.5-29.3-66.4-66.4-66.4ZM187.8,505.2v-.6c-21.5,0-38.9-19.1-38.9-40.7s17.9-38.9,40.1-38.9c20.9,1.2,38.9,17.9,38.9,40.1s-17.9,40.1-40.1,40.1Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M333.8,399.9c-36.5,0-65.8,29.3-65.8,66.4s29.3,66.4,66.4,66.4,65.8-31.7,65.8-67.6-29.9-65.2-66.4-65.2ZM373.9,467.5c0,21.5-16.2,38.9-38.9,38.9s-40.1-17.3-40.1-40.1,17.9-40.1,40.1-40.1c21.5,1.2,38.9,17.9,38.9,40.1,0,0,0,1.2,0,1.2Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M48.5,446.6h16.7c14.4,1.8,25.7-2.4,34.7-14.4,3.6-4.8,7.8-16.2,4.8-20.3s-8.4-1.8-12.6-1.8h-7.8c-2.4,0-3.6-4.2-3.6,3s-4.2,9-10.8,9H26.3c-4.2,0-5.4,1.2-5.4,5.4v43.7c0,3.6,1.2,5.4,3,7.8,7.8,10.8,17.9,15.6,36.5,15.6v.6h25.1c12.6,0,18.5-6.6,18.5-19.1s-1.2-5.4-5.4-5.4h-44.3c-7.8,0-10.2-2.4-10.2-10.2v-9.6c0-3-1.8-4.2,4.2-4.2Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M748.8,235.9v120.3H19.8v29.3h608.3v39.4h-.8c-8,0-14.5,6.5-14.5,14.5s6.5,14.5,14.5,14.5h.8v.3h32v-.3h.8c8,0,14.5-6.5,14.5-14.5s-6.5-14.5-14.5-14.5h-.8v-39.4h88.6v115.5h29.3V235.9h-29.3Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSteeringrRearAxle);
export default __webpack_public_path__ + "static/media/steeringr-rear-axle.dfec0dec2b84ce529ffa76851f1c0c8c.svg";
export { ForwardRef as ReactComponent };